import React, {useState, useEffect, useRef } from "react";
import { PaginationControl } from 'react-bootstrap-pagination-control';
import {useStoreGlobal} from '../../../stores/Global'
import {useShallow} from 'zustand/react/shallow'
export default () => {
    const _updateFiltros= useStoreGlobal(useShallow((state) => state._updateFiltros));
    const _filtros= useStoreGlobal(useShallow((state) => state._filtros));
    const _totalBusqueda= useStoreGlobal(useShallow((state) => state._totalBusqueda));
    const _totalPage= useStoreGlobal(useShallow((state) => state._totalPage));
    const _updatePage= useStoreGlobal(useShallow((state) => state._updatePage));
    const [page, setPage] = useState(0);
    const paginaInicial = useRef(null);
    
    useEffect(() => {
        let totalPage= 0;
        if (page === 1 ){
            setPage(1);
        }
        else{
            totalPage= _totalPage.page !== undefined ? _totalPage.page : 1;
            setPage(totalPage);
        }
    }, [paginaInicial, page]);
    return <PaginationControl
        page={page}
        between={3}
        total={_totalBusqueda.totalDatos}
        limit={_filtros.paginaFin}
        last={true}
        changePage={(page) => {
            _updateFiltros({paginaInicial: (page * 10) - 10});
            setPage(page);
            _updatePage({page: page});
            $("#search").trigger("click");
        }}
        ellipsis={1}
    />
}



